import MuiTableRow, { TableRowProps } from '@mui/material/TableRow';
import { Theme } from '@mui/material/styles';
import { withStyles } from 'tss-react/mui';
import classNames from 'classnames';

interface IProps extends TableRowProps {
  /** Use a lighter background color */
  lightBackground?: boolean;
  intermediateBackground?: boolean;
  parentBackground?: boolean;
  classes?: any;
}

// FIXME: färger till tema
const styles = (theme: Theme): any => ({
  hover: {
    backgroundColor: theme.customProperties.EkonomiskAnalysRowColors.lightBg,
  },
  selected: {
    backgroundColor: theme.customProperties.EkonomiskAnalysRowColors.lightBg,
  },
  parent: {
    backgroundColor: theme.customProperties.EkonomiskAnalysRowColors.parentBg,
  },
  intermediate: {
    backgroundColor: theme.customProperties.EkonomiskAnalysRowColors.mediumBg,
  },
  light: {
    backgroundColor: theme.palette.background.paper,
  },
  root: {},
});

const EDTableRow = (props: IProps) => {
  const {
    lightBackground: light,
    parentBackground: parent,
    intermediateBackground: intermediate,
    classes,
    className,
    ...other
  } = props;
  const {
    light: lightClassName,
    parent: parentClassName,
    intermediate: intermediateClassName,
    ...otherClasses
  } = classes;

  return (
    <MuiTableRow
      classes={{ ...otherClasses }}
      {...other}
      className={classNames(
        {
          [lightClassName]: light,
          [parentClassName]: parent,
          [intermediateClassName]: intermediate,
        },
        className
      )}
    />
  );
};

export default withStyles(EDTableRow, styles);
